import { withStyles } from '@material-ui/core';
import * as React from 'react';
export var BaseCheckbox = withStyles({
    root: {
        display: 'inline-flex',
        marginBottom: 'unset',
        marginRight: function (props) { return props.marginRight || 8; },
    },
    label: {
        color: '#899095',
        fontSize: 9,
        fontWeight: 600,
        padding: 7,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    checkbox: {
        height: 20,
        width: 20,
        borderRadius: 2,
        borderWidth: 1,
        zIndex: 2,
        margin: 8,
        backgroundColor: 'white',
        borderColor: '#CED7DD',
        borderStyle: 'solid',
        alignSelf: 'center',
        cursor: 'pointer',
        '& input': {
            display: 'none'
        },
        '& div': {
            width: 10,
            height: 7,
            margin: '4px 3px 3px 4px',
            transform: 'rotate(-45deg)',
            borderColor: 'black',
            borderStyle: 'solid',
            borderWidth: '0 0 1px 1px',
            visibility: 'hidden'
        },
        '& .selected': {
            visibility: "visible"
        }
    }
})(function (_a) {
    var $checked = _a.$checked, classes = _a.classes, label = _a.label, checked = _a.checked, readOnly = _a.readOnly;
    return React.createElement("label", { className: classes.root, onClick: function (e) {
            e.stopPropagation();
            if ($checked && !readOnly) {
                $checked.set(!$checked.value);
            }
        } },
        React.createElement("div", { className: classes.checkbox },
            React.createElement("div", { className: $checked ?
                    $checked.value ? 'selected' : ''
                    : checked ? 'selected' : '' })),
        label ? React.createElement("span", { className: classes.label }, label) : null);
});
//# sourceMappingURL=checkbox.js.map